import { createSlice } from "@reduxjs/toolkit";
import {
  createPayment,
  fetchPaymentsByInvoice,
  fetchInvoicePaymentsByAppointmentId,
  fetchAllPayments,
} from "../thunks/paymentsThunk";

const paymentsSlice = createSlice({
  name: "payments",
  initialState: {
    payments: [],
    status: "idle",
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalPayments: 0,
    invoicePayments: [],
    appointmentPayments: [],
    currentPayment: [],
  },
  reducers: {
    clearAppointmentPayments: (state) => {
      state.appointmentPayments = [];
    },
    setCurrentPayment: (state, action) => {
      state.currentPayment = action.payload;
    },
    clearInvoicePayments: (state) => {
      state.invoicePayments = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle payment creation
      .addCase(createPayment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createPayment.fulfilled, (state, action) => {
        console.log('Current state:', state);
        state.status = "succeeded";
        state.payments.push(action.payload);
        if (!state.appointmentPayments) {
          state.appointmentPayments = [];
        }
        state.appointmentPayments.push(action.payload);
      })
      .addCase(createPayment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Handle fetching payments by invoice
      .addCase(fetchPaymentsByInvoice.pending, (state) => {
        state.status = "loading";
        state.invoicePayments = [];
        state.error = null;
      })
      .addCase(fetchPaymentsByInvoice.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.invoicePayments = action.payload;
      })
      .addCase(fetchPaymentsByInvoice.rejected, (state, action) => {
        state.status = "failed";
        state.invoicePayments = [];
        state.error = action.payload;
      })
      .addCase(fetchInvoicePaymentsByAppointmentId.pending, (state) => {
        state.status = "loading";
        state.appointmentPayments = [];
        state.error = null;
      })
      .addCase(fetchInvoicePaymentsByAppointmentId.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.appointmentPayments = action.payload.payments;
      })
      .addCase(fetchInvoicePaymentsByAppointmentId.rejected, (state, action) => {
        state.status = "failed";
        state.appointmentPayments = [];
        state.error = action.payload;
      })
      .addCase(fetchAllPayments.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllPayments.fulfilled, (state, action) => {
        console.log("payload", action.payload);
        state.status = "succeeded";
        state.payments = action.payload.payments;
        state.currentPage = action.payload.currentPage;
        state.totalPages = action.payload.totalPages;
        state.totalPayments = action.payload.totalPayments;
      })
      .addCase(fetchAllPayments.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearAppointmentPayments, setCurrentPayment, clearInvoicePayments } = paymentsSlice.actions;
export default paymentsSlice.reducer;
